import React from "react";
const bg_img = '/img/bgs/biz-effect-home.svg'

const HomeEffectLines = [
    {
        "text": "Сокращение звонков в колл-центры (в год)",
        "percent": 30,
        "style": "items-start justify-start xl:flex-row xl:items-center xl:justify-start",
        "textStyle": "text-left w-[130px]",
        "circleStyle": "",
        "flexDirection": "flex-col-reverse xl:flex-row mt-[40px] xl:mt-[0px]",
        "inner_text_style": "",
        "order": 1
    },
    {
        "text": "Сокращение времени до выхода на рынок",
        "percent": 10,
        "style": "items-start justify-end xl:flex-row-reverse xl:items-center xl:justify-start",
        "textStyle": "text-right w-[130px]",
        "circleStyle": "",
        "flexDirection": "flex-col-reverse xl:flex-row-reverse mt-[40px] xl:mt-[0px]",
        "inner_text_style": "w-[120px] xl:w-[125px] pr-[10px] lg:pr-[0px] justify-self-end ",
        "order": 5
    },
    {
        "text": "Улучшение среднего времени восстановления систем (MTTR)",
        "percent": 50,
        "style": "items-start justify-start xl:flex-row xl:items-center xl:justify-start",
        "textStyle": "text-left w-[130px]",
        "circleStyle": "",
        "flexDirection": "flex-col-reverse xl:flex-row mt-[20px] xl:mt-[40px]",
        "inner_text_style": "w-[160px] xl:ml-[-30px]",
        "order": 2
    },
    {
        "text": "Сокращение времени отклика на запрос",
        "percent": 50,
        "style": "items-start justify-end xl:flex-row-reverse xl:items-center xl:justify-start",
        "textStyle": "text-right w-[130px]",
        "circleStyle": "",
        "flexDirection": "flex-col-reverse xl:flex-row-reverse mt-[20px] xl:mt-[40px]",
        "inner_text_style": "w-[120px] pr-[10px] lg:pr-[0px] xl:w-[110px] justify-self-end",
        "order": 4
    },
    {
        "text": "Улучшение решения задач в области ИТ Ops, QA и разработки",
        "percent": 50,
        "style": "text-center justify-center items-center xl:flex-col-reverse xl:items-center xl:justify-center",
        "textStyle": "text-center w-[160px]",
        "circleStyle": "",
        "flexDirection": "flex-col-reverse xl:flex-col-reverse  mt-[-50px] xl:mt-[-40px]",
        "inner_text_style": "w-[140px]",
        "order": 3
    }
]


const PercenterCircle = ({ percent, circleStyle }) => {
    return (
        <div className={`w-[62px] h-[62px] bg-[#d3aa86] flex items-center justify-center font-semibold text-white text-2xl rounded-[31px] mb-[10px]  ${circleStyle}`}>
            {percent}%
        </div>
    )
}

const PercenterLine = ({ text, percent, style, textStyle, circleStyle, flexDirection, inner_text_style }) => {
    return (
        <div className={`flex flex-grow min-h-[135px] w-[50%] ${style}`}>
            <div className={`flex ${flexDirection} items-center justify-center`}>
                <div className={`[font-family:'Open_Sans-Regular',Helvetica] font-normal text-[#544a28] text-xs tracking-[0] leading-[normal] ${textStyle}`}>
                    <div className={`${inner_text_style}`}>
                        {text}
                    </div>
                </div>
                <PercenterCircle percent={percent} circleStyle={circleStyle} />
            </div>
        </div>
    )
}
function HomeEffect() {
    return (
        <div className="relative w-full md:w-[620px] h-auto mt-[100px] flex justify-center items-center">
            <div className="w-full z-20">
                <div className="text-center text-2xl xl:text-3xl font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text">
                    Влияние на бизнес
                </div>

                <div className="flex justify-center w-full">
                    <div className="w-full flex flex-wrap h-[600px] max-w-[360px] md:max-w-[420px] xl:max-w-[620px] pt-[210px]">
                        {HomeEffectLines.map((line, index) => (
                            <PercenterLine key={index} {...line} />
                        ))}
                    </div>
                </div>
            </div>

            <img src={bg_img} alt="bg" className="absolute w-[200px] sm:w-[250px] z-10" />


        </div>
    );
};

export default HomeEffect
export {
    HomeEffectLines
}
